import { createFileRoute, redirect } from "@tanstack/react-router";
const SLUG = "pros-and-cons-of-solar-power";
export const Route = createFileRoute("/pros-and-cons-of-solar-power")({
  beforeLoad: () => { throw redirect({ to: "/blog/$slug", params: { slug: SLUG }, statusCode: 301 }); },
});
